<template>
    <b-card class="mb-5">
        <b-row class="mb-2">
            <b-col md="10">
                <h3>{{$route.name}}</h3>
                <b-breadcrumb>
                    <b-breadcrumb-item><router-link to="/dashboard/">Dashboard</router-link></b-breadcrumb-item>
                    <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
                </b-breadcrumb>
            </b-col>
            <b-col md="2 mt-4">
                <b-button variant="primary" class="float-right btn-custom" :to="'supplier/add-supplier'"><font-awesome-icon icon="plus" /></b-button>
            </b-col>
        </b-row>
        <div class="border-bottom mb-2"></div>
        <b-row class="mt-3 mb-2">
            <b-col md="4 mb-2">
                <b-form-input  placeholder="Supplier ID"/>
            </b-col>
            <b-col md="4 mb-2">
                <b-form-input placeholder="Supplier Name"/>
            </b-col>
        </b-row>
        <paginated-table ref="dataTable" :can-show="true" :can-delete="false" :can-edit="true" :can-approve="false" :data-url="apiUrl.supplier" :can-reject="false" :data-key="dataKey" :data-columns="columns" :data-params="['supplier_uuid', 'type', 'name', 'supplier_id']">
        </paginated-table>
    </b-card>
</template>

<script>
    import PaginatedTable from '@/components/PaginatedTable'
    export default {
        name: 'supplier-index',
        components: {
            PaginatedTable
        },
        data () {
            return {
                // isLoadingBranch: false,
                dataKey: 'supplier',
                apiUrl: {
                    supplier : window.AppConfig.apiUrl + 'supplier'
                },
                columns: [
                    {
                        key: 'supplierId',
                        label: 'Supplier ID',
                        sortable: true
                    },
                    {
                        key: 'name',
                        label: 'Supplier Name',
                        sortable: true
                    },
                    {
                        key: 'address',
                        label: 'Address',
                        sortable: true
                    },
                    {
                        key: 'actions',
                        label: 'Details'
                    }
                ],
                tableFilter: {
                    // supplier_uuid: this.$route.query.supplier_uuid,
                    // company: null,
                    // branch_uuid: this.$route.query.branch_uuid,
                    // branch: null,
                    // supplier_id: this.$route.query.supllier_id,
                    // type: this.$route.query.type,
                    // typeSupplier: null,
                    // name: this.$route.query.name
                },
                // companyList: [
                //     {
                //         value: null,
                //         text: 'Company Group'
                //     }
                // ],
                // branchList: [
                //     {
                //         value: null,
                //         text: 'Branch'
                //     }
                // ],
                // typeList: [
                //     {
                //         value: null,
                //         text: 'Type'
                //     },
                //     {
                //         value: 'Company',
                //         text: 'Company'
                //     },
                //     {
                //         value: 'Government',
                //         text: 'Government'
                //     },
                //     {
                //         value: 'Individual',
                //         text: 'Individual'
                //     }
                // ],
            }
        },
        watch: {
            // 'tableFilter.company' (value) {
            //     this.getBranch(value)
            // },
            // 'tableFilter.branch' () {
            //     this.doFilter()
            // },
            // 'tableFilter.typeCustomer' () {
            //     this.doFilter()
            // },
            // 'tableFilter.name' () {
            //     this.doFilter()
            // },
            // 'tableFilter.customer_id' () {
            //     this.doFilter()
            // }
        },
        mounted() {
            // this.getSupplier()
        },
        methods: {
            // doFilter () {
            //     this.tableFilter.supplier_uuid = this.tableFilter.supplier
            //     // this.tableFilter.branch_uuid = this.tableFilter.branch
            //     this.tableFilter.type = this.tableFilter.typeSupplier
            //     this.$refs.dataTable.doFilter(this.tableFilter)
            // },
            // getSupplier () {
            //   this.$http.get(this.apiUrl.supplier ).then(response => {
            //     response.data._embedded.supplier.forEach(data => {
            //         this.companyList.push({
            //           value: data.uuid,
            //           text: data.name
            //         })
            //     })
            //   })
            // },
            // getBranch (companyUuid = null) {
            //   this.isLoadingBranch = true
            //   if (companyUuid != null && this.tableFilter.company != null) {
            //       this.doFilter()
            //       this.tableFilter.branch_uuid = this.tableFilter.branch
            //       this.tableFilter.branch = null
            //       this.tableFilter.company_uuid = this.tableFilter.company
            //   } else {
            //       this.doFilter()
            //       this.tableFilter.branch = null
            //       this.tableFilter.company = null
            //   }
            //   this.$http.get(window.AppConfig.apiUrl + 'branch?limit=100&company_uuid=' + companyUuid + '&is_active=1').then(response => {
            //     this.branchList = []
            //     this.isLoadingBranch = false
            //     response.data._embedded.branch.forEach(data => {
            //         this.branchList.push({
            //           value: data.uuid,
            //           text: data.name
            //         })
            //     })
            //   }).catch(error => {
            //       window.consoleLog(error)
            //       this.isLoadingBranch = false
            //   })
            // },
            getDateTime (value) {
                if (value !== null) {
                    return this.$moment(value).format('YYYY-MM-DD HH:mm')
                } else {
                    return '-'
                }
            },
            reset () {
                this.tableFilter.requestedBy = null
            },
            getStatusColor (val) {
                switch (val) {
                case 'Supplier':
                    return 'info'
                    // eslint-disable-next-line no-unreachable
                    break
                }
            }
        }
    }
</script>